var map = {
	"./el_vegetables_green_cart.png": 20544,
	"./en_vegetables_green_cart.png": 80850,
	"./it_vegetables_green_cart.png": 40348,
	"./ro_vegetables_green_cart.png": 78026,
	"./uk_vegetables_green_cart.png": 49151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63104;